import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type HelpTopicProps = {
  key: string;
  description: string;
  descriptionFieldPlaceholder?: string;
};

const HelpTopic = ({
  key = '',
  description = '',
  descriptionFieldPlaceholder = '',
}: Partial<HelpTopicProps> = {}): HelpTopicProps => {
  return {
    key,
    description,
    descriptionFieldPlaceholder,
  };
};

type HelpCategoryProps = {
  key: string;
  description: string;
  topics: Array<HelpTopicProps>;
};

const HelpCategory = ({
  key = '',
  description = '',
  topics = [],
}: Partial<HelpCategoryProps> = {}): HelpCategoryProps => {
  return {
    key,
    description,
    topics: topics.map((t) => t),
  };
};

type HelpTopicsListProps = {
  categories?: Array<HelpCategoryProps>;
  outages?: Array<Array<PartialMessageProps>>;
};

const HelpTopicsList = ({ categories = [], outages = [] }: HelpTopicsListProps = {}) => {
  return {
    categories: categories.map((c) => c),
    outages: outages.map((o) => o),
  };
};

// @ts-expect-error
export { HelpCategory, HelpCategoryProps, HelpTopic, HelpTopicProps, HelpTopicsList, HelpTopicsListProps };
